import { AxiosError } from 'axios';
import type { ProcessedBackendError } from '@/interfaces';

const capitalizeMessage = (message: string): string =>
  message
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const parseBackendReason = (error: Error | ProcessedBackendError): string => {
  if ('statusCode' in error && 'reason' in error) {
    if (Array.isArray(error.reason)) {
      return error.reason.map((reason) => capitalizeMessage(reason)).join(', ');
    }
    return capitalizeMessage(error.reason);
  }

  return capitalizeMessage(error.message || 'Unknown error');
};

export const processBackendError = (error: unknown, defaultMessage: string): Error | ProcessedBackendError => {
  if (error instanceof AxiosError && error.response?.data) {
    const backendData = error.response.data;

    if (backendData && typeof backendData === 'object' && 'statusCode' in backendData && 'reason' in backendData) {
      const message = parseBackendReason(backendData as ProcessedBackendError);
      const customError = new Error(message) as ProcessedBackendError;

      customError.statusCode = backendData.statusCode;
      customError.timestamp = backendData.timestamp;
      customError.path = backendData.path;
      customError.reason = backendData.reason;
      customError.httpStatus = error.response.status;

      return customError;
    }
  }

  if (error instanceof Error) {
    return error;
  }

  return new Error(defaultMessage);
};
